(ns manage.slate-editor.mentions
  (:require ["slate" :as slate]
            [cljs-bean.core :refer [->js]]
            [clojure.string :as str]
            [manage.slate-editor.common :as common]))

(defn withMentions [^js editor]
  (let [original-is-inline (.-isInline editor)
        original-is-void (.-isVoid editor)
        original-markable-void (.-markableVoid editor)]
    (doto editor
      (aset "isInline"
            (fn [element]
              (or (= (.-type element) "mention")
                  (original-is-inline element))))
      (aset "isVoid"
            (fn [element]
              (or (= (.-type element) "mention")
                  (original-is-void element))))
      (aset "markableVoid"
            (fn [element]
              (or (= (.-type element) "mention")
                  (original-markable-void element)))))))

(defn insert-mention [^js editor user]
  (slate/Transforms.insertNodes editor (->js [{:type common/mention-node-type
                                               :id (:id user)
                                               :children [{:text "@"}
                                                          {:text (str (:id user))}]}]))

  (slate/Transforms.move editor)
  (.insertText editor " "))

(defn search-users [search users]
  (if (seq search)
    (let [mention-pattern (re-pattern (str "(?i)" (str/replace (subs search 1) #"[^A-Za-z0-9]" "\\\\$0")))]
      (filter
       (fn [{:keys [name email]}]
         (or (re-find mention-pattern name)
             (re-find mention-pattern email)))
       users))
    users))

